/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewChild, inject, computed } from '@angular/core'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { FilterService } from '@progress/kendo-angular-grid'
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  FilterOperator,
} from '@progress/kendo-data-query'

import { SessionService } from '@hunt/services'

import { BaseCustomFilterComponent } from '../../../../../shared/components/custom-filters/base-custom-filter.component'
import { DashboardStateService } from '../../dashboard-state-service'

@Component({
  standalone: false,
  selector: 'dashboard-dropdown-filter',
  template: `
    <kendo-dropdownlist
      #drop
      [showOperators]="true"
      [field]="field"
      [data]="data"
      (valueChange)="onChange($event)"
      [defaultItem]="defaultItem"
      [value]="selectedValue"
      [valuePrimitive]="true"
      [textField]="textField"
      [valueField]="valueField"
    >
    </kendo-dropdownlist>
  `,
  styles: [
    `
      .k-input-solid {
        background-color: var(--background-overlay-default);
        border-radius: var(--corner-radius-tertiary);
        border: var(--stroke-size-primary) solid var(--border-default);
        background: var(--background-function-inset);
      }
    `,
  ],
})
export class DashboardDropDownFilterComponent extends BaseCustomFilterComponent {
  dashboardStateService = inject(DashboardStateService)

  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
  @ViewChild('drop', { read: DropDownListComponent })
  public list: DropDownListComponent

  @Input() public filter: CompositeFilterDescriptor
  @Input() public data: any[]
  @Input() public field: string
  @Input() public textField: string
  @Input() public valueField: string

  public get selectedValue(): unknown {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field }) => {
          return field === this.field
        },
      )

      if (filter && filter.value && this.data) {
        const item: any[] = this.data.filter((item) => {
          return item.id === filter.value
        })

        if (item && item[0]) {
          return item[0].id
        }
      }
      return null
    }
  }

  public get defaultItem(): { [Key: string]: unknown } {
    return {
      [this.textField]: 'Select...',
      [this.valueField]: null,
    }
  }

  // Constructor needed for proper filter functioning

  constructor() {
    const filterService = inject(FilterService, { optional: true })

    super(filterService)
  }

  public resetDefault(): void {
    this.filter.filters = this.filter.filters.filter(
      (field) => (field as FilterDescriptor).field !== this.field,
    )
  }

  public onChange(value: unknown): void {
    // if (value === null) {
    this.filter.filters = this.filter.filters.filter(
      (field) => (field as FilterDescriptor).field !== this.field,
    )
    if (value != null) {
      this.filter.filters.push({
        // add a filter for the field with the value
        field: this.field,
        operator: FilterOperator.EqualTo,
        value: value,
      })
    }
  }
}
